import { ILabelStyle } from '../models/index.js';
export const labelStyle: ILabelStyle = {
	children: {
		wrapper: {
			font: {
				size: '12px',
			},
		},
	},
};
